const renderHits = (renderOptions, isFirstRender) => {
  const { hits, widgetParams } = renderOptions;

  if (isFirstRender) return;

  // Empty container
  widgetParams.container.innerHTML = "";

  // Insert results
  if (hits.length > 0) {
    widgetParams.container.innerHTML = `
      <h5 class="search-dropdown__source-header">${
        widgetParams.container.dataset.resultsTitle
      }</h5>

      <ul class="search-dropdown__items-list list-unstyled">
        ${hits
          .map(
            ({
              blog,
              handle,
              title,
              query,
              queryID,
              index,
              position,
              objectID,
            }) => {
              let link;

              switch (widgetParams.type) {
                case "search":
                  link = `
                  <a
                    href="/search?q=${encodeURIComponent(query)}"
                    title="${query}"
                    class="search-dropdown__link-collection"
                    data-algolia-queryid="${queryID}"
                    data-algolia-index="${index}"
                    data-algolia-object-ids="${objectID}"
                    data-algolia-position="${position}"
                  >
                    ${query}
                  </a>
                `;
                  break;
                case "collection":
                  link = `
                  <a
                    href="/collections/${handle}"
                    title="${title}"
                    class="search-dropdown__link-collection"
                    data-algolia-queryid="${queryID}"
                    data-algolia-index="${index}"
                    data-algolia-object-ids="${objectID}"
                    data-algolia-position="${position}"
                  >
                    ${title}
                  </a>
                `;
                  break;
                case "article":
                  link = `
                  <a
                    href="/blogs/${blog.handle}/${handle}"
                    title="${title}"
                    class="search-dropdown__link-article"
                    data-algolia-queryid="${queryID}"
                    data-algolia-index="${index}"
                    data-algolia-object-ids="${objectID}"
                    data-algolia-position="${position}"
                  >
                    ${title}
                  </a>
                `;
                  break;
                default:
                  break;
              }

              return `
              <li class="search-dropdown__item">
                ${link}
              </li>
            `;
            }
          )
          .join("")}
      </ul>
    `;

    widgetParams.container.querySelectorAll("a").forEach((el) => {
      el.addEventListener("click", (e) => {
        e.preventDefault();

        const clickData = {
          index: el.dataset.algoliaIndex,
          eventName: `search dropdown - ${widgetParams.type} link click`,
          queryID: el.dataset.algoliaQueryid,
          objectIDs: [el.dataset.algoliaObjectIds],
          positions: [Number(el.dataset.algoliaPosition)],
        };

        // Set the logged in customer user token
        if (window.algolia.customer) {
          clickData.authenticatedUserToken = `${window.algolia.customer}`;
        }

        aa("clickedObjectIDsAfterSearch", clickData);

        window.location.href = el.href;
      });
    });
  }
};

export const relatedResults =
  window.instantsearch.connectors.connectHits(renderHits);
